
import Avatar from "@prisma-cms/front/lib/modules/Avatar";

export default Avatar;
